import React from 'react';
import YouTube from 'react-youtube';
import getYouTubeID from 'get-youtube-id';

class YouTubeVideo extends React.Component {
  handleEvent = interaction => {
    const descriptiveInteraction = this.videoState(interaction.data);

    if (descriptiveInteraction) {
      analytics.track('Video Interaction', {
        page: window.location.href,
        videoURL: this.props.videoURL,
        interaction: descriptiveInteraction,
      });
    }
  };

  videoState = state => {
    switch (state) {
      case YouTube.PlayerState.ENDED:
        return 'Ended';
      case YouTube.PlayerState.PLAYING:
        return 'Playing';
      case YouTube.PlayerState.PAUSED:
        return 'Paused';
      default:
        null;
    }
  };

  render() {
    const options = {
      playerVars: {
        autoplay: 1,
        modestbranding: 1,
        rel: 0,
      },
    };

    return (
      <YouTube
        videoId={getYouTubeID(this.props.videoURL)}
        opts={options}
        onStateChange={this.handleEvent}
      />
    );
  }
}

export default YouTubeVideo;
